<style>
    table {
        border: 1px solid gainsboro;
        width: 100%;
        border-collapse: collapse;
    }

    th {
        background-color: aliceblue;
        color: black;
        padding: 10px;
        border: 1px solid gainsboro;
    }

    td {
        padding: 10px;
        border: 1px solid gainsboro;
    }

    .content-holder {
        word-break: break-all;
    }
</style>
<script>
    import * as Common from '../Common.js'
    import {onMount} from 'svelte'

    let userId = ""
    let unscreenedContent = []

    onMount(() => {
        Common.getData('unscreened')
        .then(data => {
            if(!data) {
                alert("Problem getting info!")
                return
            }
            unscreenedContent = data
        })
    })

    function createLink(contentType, refId) {
        switch(contentType) {
            case Common.UnscreenedContent_Item:
                return '<a href="#/item/' + refId + '">item/' + refId + '</a>'
            case Common.UnscreenedContent_Comment:
                return '<a href="#/comment/' + refId + '">comment/' + refId + '</a>'
            default:
                return ''
        }
    }

    function banUser(userId) {
        Common.postData('banuser/' + userId)
        .then(r => {
            if(!r.ok) {
                alert("Problem banning user!")
                return
            }
            Common.CreateNotification({body: "Banned User with id=" + userId}, 1000)
            userId = "";
        })
    }

    function screenContent(contentType, refId) {
        let typeString =
        (contentType === Common.UnscreenedContent_Item) ? "item" : "comment"
        Common.postData("screen/" + typeString + "/" + refId)
        .then(r => {
            if(!r.ok) {
                alert("Could not screen content!")
                return
            }
            unscreenedContent = unscreenedContent.filter(c => !(c.contenttype === contentType && c.id === refId))
            Common.CreateNotification({body: "Content marked as screened."}, 1000)
        })
    }

</script>
<div style="padding: 10px;">
    <h2>Unscreened Content</h2>
    <p>
        The following table contains content that has been added but not screened. Unscreened content will not display attached images to other users. Marking an item as screened will tweet the item; mentioning the city.
    </p>
</div>
<table>
    <tr>
        <th>Link</th>
        <th>Content Created Time</th>
        <th>User</th>
        <th>Content</th>
        <th>Area Twitter Username</th>
        <th>Actions</th>
    </tr>
    {#each unscreenedContent as c}
        <tr>
            <td>{@html createLink(c.contenttype, c.id)}</td>
            <td>{Common.UnixTimeToDateStr(c.createtime)}</td>
            <td><a href={"#/user/" + c.user_id}>user/{c.user_id}</a></td>
            <td class="content-holder">{c.content}</td>
            <td>{c.areatwitterusername}</td>
            <td>
                <button on:click={() => banUser(c.user_id)}>Ban</button>
                <button on:click={() => screenContent(c.contenttype, c.id)}>Screen</button>
            </td>
        </tr>
    {/each}
</table>